import {
  Injectable, Renderer2, RendererFactory2, RendererStyleFlags2,
} from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class WindowScrollingService {
  private renderer: Renderer2;

  constructor(private rendererFactory: RendererFactory2) {
    this.renderer = this.rendererFactory.createRenderer(null, null);
  }

  public disable(): void {
    this.renderer.setStyle(document.body, 'overflow', 'hidden', RendererStyleFlags2.Important);
  }

  public enable(): void {
    this.renderer.removeStyle(document.body, 'overflow');
  }
}
